<template>
  <div id="itembank-form">
    <!-- begin breadcrumb -->
    <ol class="breadcrumb pull-right">
      <li><router-link :to="{path: '/'}">Home</router-link></li>
      <li>Menu</li>
      <li class="active">Create</li>
    </ol>
    <!-- end breadcrumb -->
    <!-- begin page-header -->
    <h1 class="page-header">Tambah Menu</h1>
    <!-- end page-header -->
    <div class="row">
      <div class="col-md-12">
        <div class="panel panel-inverse">
          <div class="panel-heading">
            <h4 class="panel-title">Form Menu</h4>
          </div>
          <div class="panel-body panel-form">
            <div class="alert alert-danger fade in m-b-15" v-if="this.errors.length > 0">
              <span class="close" data-dismiss="alert">&times;</span>
              <strong>Terjadi kesalahan!</strong>
              <ul>
                <li v-for="(message, key) in this.errors" v-bind:key="key">{{message}}</li>
              </ul>
            </div>
            <form class="form-horizontal form-bordered">
              <div class="form-group" v-bind:class="{ 'has-error': errors.indexOf('type_id') >= 0 }">
                <label class="col-md-2 control-label">Type *</label>
                <div class="col-md-8 col-xs-12">
                  <select v-model="form.type_id" class="form-control">
                    <option v-for="menuType in menuTypes" :key="menuType.id" :value="menuType.id">{{menuType.name}}</option>
                  </select>
                </div>
              </div>
              <div class="form-group" v-bind:class="{ 'has-error': errors.indexOf('information') >= 0 }">
                <label class="col-md-2 control-label">Deskripsi</label>
                <div class="col-md-8 col-xs-12">
                  <input class="form-control" type="text" v-model="form.description"/>
                </div>
              </div>
              <div class="form-group" v-bind:class="{ 'has-error': errors.indexOf('status_tag') >= 0 }">
                <label class="col-md-2 control-label">Status Tag (Optional)</label>
                <div class="col-md-8 col-xs-12">
                  <input class="form-control" type="text" v-model="form.status_tag"/>
                </div>
              </div>
              <div class="form-group">
               <label class="col-md-2 control-label">Upload Asset</label>
                <div class="col-md-8 col-xs-12">
											<div class="row">
												<div class="col-md-4" v-if="form.picture">
													<img class="img-fluid" :src="form.picture" />
												</div>
												<div class="col-md-8">
													<input type="file" class="form-control" accept="image/*" @change="handleChangePicture($event)" />
												</div>
											</div>
										</div>
              </div>
              <div class="form-group">
                 <label class="col-md-2 control-label"></label>
                 <div class="col-md-8 col-xs-12">

                  <button v-if="$route.query.id" type="button" class="btn btn-success btn-md" @click="save()">Simpan Perubahan</button>
                  <button v-else type="button" class="btn btn-success btn-md" @click="save()">Simpan</button>

                 </div>
               </div>
            </form>
          </div>
        </div>
      </div>
    </div>
    <app-spinner v-if="isLoading"></app-spinner>
  </div>
</template>

<script>
import ContentService from '@/services/content.js'
import Spinner from '@/components/plugins/Spinner'

export default {
  name: 'content-article-form',
  components: {
    'app-spinner': Spinner
  },
  data: function() {
    return {
      compiledContent: '',
      labelQuery: '',
      isLoading: false,
      listSection: [],
      form: {
        id: 0,
        name: null,
        description: null,
        information: null,
        picture: null,
        status: 'HIDDEN',
        type_id: null,
        status_tag: null
      },
      selectedPicture: null,
      menuTypes: [],
      errors: []
    }
  },
  mounted: function () {
    this.loadSection()
    this.loadMenuTypes()
    if (this.$route.query.id) {
      this.queryId = this.$route.query.id
      this.fetchData()
    }
  },
  methods: {
    fetchData: function () {
			var data = this.$store.state.content.editContent
      this.form = {
        id: data.id,
        name: data.name,
        description: data.description,
        display_name: data.display_name,
        picture: data.picture,
        status: data.status,
        status_tag: data.status_tag,
        type_id: data.type.id
      }
		},
    loadSection: function() {
      var context = this
      ContentService.getContentDetailByType('ARTICLE',function (result) {
        if(result.success) context.listSection = result.data
        else alert('pengambilan section list gagal')
      })
    },
    loadMenuTypes: function() {
      var context = this
      ContentService.getMenuTypes(function(result) {
        if (result.success) context.menuTypes = result.data
      })
    },
    save: function() {
      var context = this

      if(this.validateForm()) {
        context.isLoading = true
        var strJSON = {
          action: 'action',
          description: this.form.description,
          status: this.form.status,
          order_number: 0,
          type_id: this.form.type_id,
          status_tag: this.form.status_tag
        }

        var context = this
        var picture = this.selectedPicture
        var formData = new FormData()

        if(!this.$route.query.id) {
            formData.append('req', JSON.stringify(strJSON))
            formData.append('file', picture)

            ContentService.menuHomeCreate(formData, function (result) {
              context.isLoading = false
              if (result.success) context.$router.push({ path: '/content/menu' })
              else alert('Gagal simpan data')
              console.log(result)
            })
        } else {
            formData.append('req', JSON.stringify(strJSON))
            if(picture !== null) formData.append('file', picture)

            ContentService.updateMenu(this.$route.query.id, formData, function (result) {
              context.isLoading = false
              if (result.success) context.$router.push({ path: '/content/menu' })
              else alert('Gagal ubah data')
            })
        }
      }
    },
    handleChangePicture: function (event) {
			const file = event.target.files[0]
			this.selectedPicture = file
			this.form.picture = URL.createObjectURL(file);
		},
    validateForm: function() {
      this.errors = []
      if(!this.form.picture) this.errors.push('Gambar wajib diisi')
      if(!this.form.status) this.errors.push('Status wajib diisi')
      if(!this.form.description) this.errors.push('Keterangan wajib diisi')
      if(!this.form.type_id) this.errors.push('Type wajib diisi')

      if(this.errors.length == 0) return true

      return false
    },
  }
}
</script>



// WEBPACK FOOTER //
// Form.vue?5de16d5a